import { useEffect, useState, useRef } from "react";
import "../styles/newsevents.scss";
import Header from "../components/header";
import Footer from "../components/footer";
import MenuTab from "../components/menu_tab";
import Banner from "../components/banner";
import PostItem from "../components/post_item";

import cis from "../assets/imgs/cis.png";
import gatitu from "../assets/imgs/gatitumeeting.jpg";
import pe from "../assets/imgs/publicparticipation.jpeg";
import waterinterruptiongatamaiyu from "../assets/imgs/waterinterruptiongatamaiyu.jpg";
import waterrestoredgatamaiyu from "../assets/imgs/waterrestoredgatamaiyu.jpg";

export default function NewsEvents(props) {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [posts, setPosts] = useState([]);
  const [totalPosts, setTotalPosts] = useState(0);
  const [offset, setOffset] = useState(0);
  
  // Create a ref for the top of the news section
  const newsTopRef = useRef(null);
  
  const LIMIT = 8;

  // Fetch paginated data whenever the offset changes
  useEffect(() => {
    fetch(`/api/news/paginated/${offset}`)
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error("Failed to fetch news");
      })
      .then((data) => {
        setPosts(data.result || []);
        setTotalPosts(Array.isArray(data.total) ? data.total[0] : data.total || 0);
        
        // Scroll smoothly to the top of the news section once data loads
        newsTopRef.current?.scrollIntoView({ behavior: "smooth" });
      })
      .catch((e) => {
        console.error(e);
      });
  }, [offset]);

  const handleNext = () => {
    if (offset + LIMIT < totalPosts) {
      setOffset((prev) => prev + LIMIT);
    }
  };

  const handlePrev = () => {
    if (offset - LIMIT >= 0) {
      setOffset((prev) => prev - LIMIT);
    }
  };

  const currentPage = Math.floor(offset / LIMIT) + 1;
  const totalPages = Math.ceil(totalPosts / LIMIT) || 1;

  return (
    <div className="body">
      <Banner />
      <Header toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />
      {toggleMenu && <MenuTab toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />}
      
      <div className="image2" ref={newsTopRef}>
        <div id="newconnection">
          <p>News & Events</p>
        </div>
      </div>

      {/* Attach ref here so it scrolls right above the heading/posts */}
      <div className="newsevents" id="newsevents">
        <div className="centerheading">
          <h5 className="decorated-heading">Be on the know...</h5>
        </div>

        <div className="posts">
          {posts.map((item) => (
            <PostItem 
              key={item.ID}
              id={item.ID}
              images={item.Images} 
              title={item.Title} 
              details={item.Description} 
              date={item.Date} 
            />
          ))}
        </div>

        {/* Pagination Controls */}
        <div className="pagination-controls" style={{ display: "flex", justifyContent: "center", gap: "1rem", margin: "2rem 0", alignItems: "center" }}>
          <button 
            onClick={handlePrev} 
            disabled={offset === 0}
            style={{ padding: "0.5rem 1rem", cursor: offset === 0 ? "not-allowed" : "pointer" }}
          >
            Previous
          </button>
          
          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button 
            onClick={handleNext} 
            disabled={offset + LIMIT >= totalPosts}
            style={{ padding: "0.5rem 1rem", cursor: offset + LIMIT >= totalPosts ? "not-allowed" : "pointer" }}
          >
            Next
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
}